// 开关——主流程
const MainRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `module/switch/index${i + 1}`,
  name: `module/switchIndex${i + 1}`,
  component: () => import(`@/views/recognize/module/switch/index${i + 1}.vue`)
}))

export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 开关——主流程，开始
    ...MainRoutes
  ]
}
